define('modules/editor/views/property_boxes/page_confirmation',['require','exports','module','./base','ldsh!../../templates/property_boxes/page_confirmation'],function(require, exports, module){
  "use strict";
  var BasePB = require("./base");
  module.exports = BasePB.extend({
    template: require("ldsh!../../templates/property_boxes/page_confirmation"),
    myEvents: {
      "change .js-confirmation-page": "updateControls",
      "change input[type=radio]": "updateSendParams",
    },
    initialize: function(){
      _.extend(this.events, this.myEvents);
      module.exports.__super__.initialize.apply(this,arguments);
    },
    updateControls: function(e){
      var behaviour = this.$(".js-confirmation-page").val();
      if(behaviour === "editor"){
        this.model.set("confirmationUrl", "");
        this.$(".js-url").hide();
      }
      else {
        this.$(".js-url").show();
      }
    },
    updateSendParams: function (el) {
      var sendParamsValue = $('input[name="sendParams"]:checked').val();
      this.model.set("sendParams", sendParamsValue);
    },
    onRender: function(){
      this.$el.i18n();
      if(this.model.get("confirmationUrl") !== ""){
        this.$(".js-confirmation-page").val("url");
      }
      this.updateControls();
    }
  });
});

